import { render, staticRenderFns } from "./Certificato.vue?vue&type=template&id=8a3a16e2&scoped=true&"
import script from "./Certificato.vue?vue&type=script&lang=js&"
export * from "./Certificato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3a16e2",
  null
  
)

export default component.exports